export default "__VITE_ASSET__407f1c8e__"